export default __webpack_public_path__ + "static/media/131995461_444019223462439_1286989546799494927_n.acfeddd0.jpg";